export const waiverSchema = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Waiver Type",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "waiverType",
      },
      {
        title: "Waiver Other Type",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "waiverother",
      },
      {
        title: "Waiver Start Date",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "waiverdate",
      },
      {
        title: "Waiver Date",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "waiverEnddate",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Comments",
        colSpan: 4,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "comments",
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/WaiverReport/WaiverSchema.js